export function isDefined<T>(value: T | undefined | null | string): value is T {
  return (
    typeof value !== 'undefined' &&
    value !== null &&
    (typeof value === 'string' ? !isEmpty(value) : true)
  );
}

export function areDefined(...args: any[]) {
  return args.every((item) => isDefined(item));
}

export function isEmpty(value: String) {
  return value.trim().length <= 0;
}